import { render, staticRenderFns } from "./RegistrationEmploymentForm.vue?vue&type=template&id=79efe8a8&"
import script from "./RegistrationEmploymentForm.vue?vue&type=script&lang=ts&"
export * from "./RegistrationEmploymentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports